import { mqMin, space, tokPx } from '@sunwebgroup/ui-components'
import { Skeleton } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { EXTRA_L_MIN_BREAKPOINT } from '../utils'

export const ImageElementButton = styled.button`
  position: relative;
`

const Wrapper = styled.div`
  gap: ${space('primitives_space_2')};
  flex-direction: column;
  display: none;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    display: flex;
  }
`

const BigImageWrapper = styled.div`
  position: relative;
`

const BigImageElementButton = styled(Skeleton)`
  display: block;
  aspect-ratio: 7 / 3;
  border-top-left-radius: ${tokPx('primitives_corner_radius_m')};
  border-top-right-radius: ${tokPx('primitives_corner_radius_m')};
  overflow: hidden;
  width: 100%;

  @media ${mqMin('primitives_breakpoint_l_min')} {
    aspect-ratio: 16 / 9;
  }

  @media (min-width: ${EXTRA_L_MIN_BREAKPOINT}) {
    aspect-ratio: 7 / 3;
  }
`

const OtherImageElement = styled(Skeleton)`
  aspect-ratio: 4 / 3;
  display: block;
  width: 100%;
  overflow: hidden;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    border-radius: unset;
  }
`

const MobileWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${space('primitives_space_8')};
  overflow-x: hidden;
  flex-wrap: nowrap;
  width: 100%;

  ${OtherImageElement}{
    border-radius: ${tokPx('primitives_corner_radius_s')};
    height: 210px;
    width: 280px;
  }

  & > * {
    flex: 0 0 280px;
  }

  @media ${mqMin('primitives_breakpoint_m_min')} {
    display: none;
  }
`

const OtherImagesWrapper = styled.div`
  display: flex;
  gap: ${space('primitives_space_2')};

  ${OtherImageElement} {
    &:first-child {
      @media ${mqMin('primitives_breakpoint_m_min')} {
        border-bottom-left-radius: ${tokPx('primitives_corner_radius_m')};
      }
    }

    &:last-child {
      @media ${mqMin('primitives_breakpoint_m_min')} {
        border-bottom-right-radius: ${tokPx('primitives_corner_radius_m')};
      }
    }
  }
`
function renderImages() {
  return (
    [...Array.from({ length: 5 })].map((_, i) => (
      <OtherImageElement key={i} />
    ))
  )
}

export function GalleryLoading() {
  return (
    <>
      <MobileWrapper>
        {renderImages()}
      </MobileWrapper>
      <Wrapper>
        <BigImageWrapper>
          <BigImageElementButton />
        </BigImageWrapper>
        <OtherImagesWrapper>
          {renderImages()}
        </OtherImagesWrapper>
      </Wrapper>
    </>
  )
}
